// extracted by mini-css-extract-plugin
export default {"headerBar":"CreateObservation_headerBar__hJRIP"};